import { render, staticRenderFns } from "./OaoSegmentedControl.vue?vue&type=template&id=4d12c04d&scoped=true"
import script from "./OaoSegmentedControl.vue?vue&type=script&lang=js"
export * from "./OaoSegmentedControl.vue?vue&type=script&lang=js"
import style0 from "./OaoSegmentedControl.vue?vue&type=style&index=0&id=4d12c04d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0d1d51ab4c56f75a7402f3cb98fb63e0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d12c04d",
  null
  
)

export default component.exports